import type { OrderZohoSync } from './types'

export function hasZohoSyncHistory(sync: OrderZohoSync): boolean {
  return Boolean(sync.salesOrderId || sync.invoiceId || sync.creditNoteId || sync.syncedAt || sync.lastError)
    || !['NOT_CONFIGURED', 'READY'].includes(sync.status)
}
